import { API_FILES_HEADERS, API_HEADERS } from "./utils";

// const { REACT_APP_LIFERAY_HOST = window.location.origin, REACT_APP_LIFERAY_SITE_SCOPE } = process.env;
const REACT_APP_LIFERAY_HOST = window?.Liferay ? window?.Liferay?.ThemeDisplay.getPortalURL() : "https://preprod-dxpa.ansut.ci"


const headers = window?.Liferay && window?.Liferay?.authToken
	? {
		'Content-Type': 'application/json',
		// 'x-csrf-token': window.Liferay.authToken,
	}
	:
	{
		'Content-Type': 'application/json',
		// "Authorization": "Basic " + btoa("test_dsi@diginfactory.com:Digin@2025$"),

	}
// var groupId = window?.Liferay?.ThemeDisplay.getScopeGroupId();
// const headers = window?.Liferay && {
// 	'Content-Type': 'application/json',
// 	"Authorization": "Basic " + btoa("dxpa@ansut.ci:thesecret"),
// }

// const headersFile = window?.Liferay && {
// 	//'Accept': 'application/json',
// 	//'Content-Type': 'multipart/form-data',
// 	"Authorization": "Basic " + btoa("dxpa@ansut.ci:thesecret"),
// }

const headersFile = window?.Liferay
	? {
		Accept: "application/json",
		"x-csrf-token": window.Liferay.authToken,
	}
	: {
		Authorization: "Basic " + btoa("test_dsi@diginfactory.com:Digin@2025$"),
		Accept: "application/json",
	};

// const buildRequestUrl = (url, path, query) => {
// 	let _queryParams = []
// 	let _strQueryParam = "";

// 	let uri = url;

// 	//Path
// 	if (path && Object.keys(path).length > 0) {
// 		for (const [key, value] of Object.entries(path)) {
// 			uri = uri.replace(`:${key}`, `${value}`);
// 		}
// 	}

// Query
// if(query && Object.keys(query).length > 0) {
//     for (const [key, value] of Object.entries(query)) {
//         if(value !== null) _queryParams.push(`${key}`=`${value}`)
//     }
//     _strQueryParam = _queryParams.length > 0 ?  "?" + _queryParams.join("&") : "";
// }

// 	return `${uri}${_strQueryParam}`;
// }






const liferayService = {
	get: (url, options = {}) => {
		return new Promise(async (resolve, reject) => {
			try {
				const response = await fetch(REACT_APP_LIFERAY_HOST + '/' + url, {
					headers: API_HEADERS,
					method: "GET",
					credentials: 'include',
					...options,
				});
				const data = await response.json();
				if (response.ok) {
					resolve(data);
				} else {
					window.Liferay?.Util.openToast({
						title: data.status,
						message: 'An error occured.',
						type: 'danger',
					});
					reject(false)
				}
			} catch (error) {
				window.Liferay?.Util.openToast({
					message: 'An error occured.',
					type: 'danger',
				});
				reject(error)
			}
		})
	},
	post: (url, payload, options = {}) => {
		return new Promise(async (resolve, reject) => {
			try {
				const response = await fetch(REACT_APP_LIFERAY_HOST + '/' + url, {
					headers: API_HEADERS,
					method: "POST",
					body: JSON.stringify(payload),
					...options
				});
				const data = await response.json();
				if (response.ok) {
					// if (window.Liferay) {
					// 	window['Liferay'].Util.openToast({
					// 		message: (options && options?.message?.success) || 'Your request has been completed.',
					// 		type: 'success',
					// 	});
					// }
					resolve(data);
				} else {
					window.Liferay?.Util.openToast({
						title: data.status,
						message: 'An error occured.',
						type: 'danger',
					});
					reject(false)
				}
			} catch (error) {
				window.Liferay?.Util.openToast({
					message: 'An error occured.',
					type: 'danger',
				});
				reject(error)
			}
		})
	},
	put: (url, payload, options = {}) => {
		return new Promise(async (resolve, reject) => {
			try {
				const response = await fetch(REACT_APP_LIFERAY_HOST + '/' + url, {
					headers: API_HEADERS,
					method: "PUT",
					body: JSON.stringify(payload),
					...options
				});
				const data = await response.json();
				if (response.ok) {
					if (window.Liferay) {
						window['Liferay'].Util.openToast({
							message: (options && options?.message?.success) || 'Your request has been completed.',
							type: 'success',
						});
					}
					resolve(data);
				} else {
					window.Liferay?.Util.openToast({
						title: data.status,
						message: 'An error occured.',
						type: 'danger',
					});
					reject(false)
				}
			} catch (error) {
				window.Liferay?.Util.openToast({
					message: 'An error occured.',
					type: 'danger',
				});
				reject(error)
			}
		})
	},

	delete: (url, options = {}) => {
		return new Promise(async (resolve, reject) => {
			try {
				const response = await fetch(REACT_APP_LIFERAY_HOST + '/' + url, {
					headers: API_HEADERS,
					method: "DELETE",
					...options,
				});
				const data = await response.json();
				console.log({ data })
				if (response.ok) {
					resolve(data);
				} else {
					window.Liferay?.Util.openToast({
						title: data.status,
						message: 'An error occured.',
						type: 'danger',
					});
					reject(false)
				}
			} catch (error) {
				window.Liferay?.Util.openToast({
					message: 'An error occured.',
					type: 'danger',
				});
				reject(error)
			}
		})
	},
	postFile: (url, formData) => {
		return new Promise(async (resolve, reject) => {
			try {
				const response = await fetch(REACT_APP_LIFERAY_HOST + "/" + url, {
					headers: API_FILES_HEADERS,
					method: "POST",
					body: formData,
				});
				const data = await response.json();
				if (response.ok) {
					resolve(data);
				} else {
					reject(false);
				}
			} catch (error) {
				reject(error);
			}
		});
	},
	// OAuth2: {
	// 	getAuthorizeURL: () => '',
	// 	getBuiltInRedirectURL: () => '',
	// 	getIntrospectURL: () => '',
	// 	getTokenURL: () => '',
	// 	getUserAgentApplication: (_serviceName) => {},
	// },
	// OAuth2Client: {
	// 	FromParameters: (_options) => {
	// 		return {};
	// 	},
	// 	FromUserAgentApplication: (_userAgentApplicationId) => {
	// 		return {};
	// 	},
	// 	fetch: (_url, _options = {}) => {},
	// },
}

export default liferayService;
